import React from "react";
import { useNavigate } from "react-router-dom";
import BottomTabBar from "../components/BottomTabBar";
import AppButton from "../components/AppButton";
import { BarChart3, TrendingUp, Eye } from "lucide-react";

export default function SalesAnalytics() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-gray-50 w-full flex flex-col pb-24 sm:pb-28">
      <div className="w-full max-w-lg sm:max-w-xl mx-auto flex-1 px-4 sm:px-5 pt-8 sm:pt-10">
        <AppButton
          variant="ghost"
          fullWidth={false}
          onClick={() => navigate("/user-settings")}
          className="mb-4"
        >
          ← Back
        </AppButton>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">
          Sales Analytics
        </h1>
        <p className="text-sm text-gray-500 mt-1 mb-6">
          Track performance across your in-store displays
        </p>

        <div className="grid grid-cols-2 gap-3 mb-6">
          {[
            { label: "Views today", value: "—", icon: Eye },
            { label: "Engagement", value: "—", icon: TrendingUp },
          ].map(({ label, value, icon: Icon }) => (
            <div
              key={label}
              className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm"
            >
              <Icon size={18} className="text-blue-500 mb-2" />
              <p className="text-2xl font-bold text-gray-900">{value}</p>
              <p className="text-xs text-gray-400 mt-0.5">{label}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 p-8 text-center shadow-sm">
          <div className="w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center mx-auto mb-4">
            <BarChart3 size={28} className="text-blue-500" />
          </div>
          <p className="text-sm font-semibold text-gray-800 mb-1">
            Analytics coming soon
          </p>
          <p className="text-xs text-gray-400 leading-relaxed max-w-xs mx-auto">
            Detailed sales and engagement metrics will appear here as your
            campaigns run on connected screens.
          </p>
        </div>
      </div>

      <BottomTabBar />
    </div>
  );
}
